const BambooHRLogoIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="6" fill="#66B710" />
    <path
      d="M15.9648 16.863C14.2484 16.863 12.7845 15.5 12.7845 13.6827C12.7845 11.8654 14.0465 10.351 16.0152 10.351C17.984 10.351 19.1955 11.9663 19.1955 13.6322C19.1955 15.4495 17.9335 16.863 15.9648 16.863ZM16.1162 9.03846C14.5008 9.03846 13.6427 9.59375 13.0369 10.1995L12.8854 10.351V5H11.5225V13.7332C11.5225 16.4087 13.5922 18.125 15.9648 18.125C18.5898 18.125 20.5585 16.1058 20.5585 13.5313C20.609 11.1082 18.4888 9.03846 16.1162 9.03846Z"
      fill="white"
    />
    <path
      d="M10.8654 10.805C10.8654 10.805 10.2596 10.704 9.75481 10.6031C9.19952 10.5021 8.94712 10.4516 8.1899 10.1488C7.48317 9.84587 6.77644 9.13914 6.17067 8.33145C5.51442 7.52375 4 6.26173 4 6.26173C4 6.26173 4.45433 6.31222 4.95913 6.41318C5.36298 6.51414 6.3726 6.81702 7.38221 7.37231C7.63462 7.47327 7.73558 7.57423 7.98798 7.72568C8.34135 7.9276 8.69471 8.28097 9.04808 8.63433C9.45192 9.03818 9.80529 9.39154 10.1082 9.74491C9.75481 9.13914 8.89663 6.91798 7.23077 5.10068C7.07933 4.89875 8.39183 5.75693 8.74519 6.11029C9.75481 7.22087 9.90625 7.82664 10.2596 8.83625L10.8654 10.805Z"
      fill="white"
    />
  </svg>
);

export default BambooHRLogoIcon;
